export enum ServiceOrderAppliedDateTypes {
    Arrival = 0,
    Departure = 1
}
